module.exports = __webpack_public_path__ + "img/forgot-illustration.1db8ec22.svg";